<div class="pt-100 unauth-container pb-50">
  <img src="/assets/images/unauthorized.png">
  <div class="fw-600 fs-24 mat-subtitle-2 mt-16"> {{ 'UNAUTHORIZED.MESSAGE' | transloco }}</div>
</div>